<template>
  <form novalidate @submit.prevent="debounceSearch">
    <div class="columns my-0">
      <div class="column is-4">
        <kst-input load-on-focus floating-label
          field="Search" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="Client"
        :data="searchData"
        :catalog="SearchCatalog"
        @input="handleInput"
      >
      <template #right>
        <div class="control">
          <template v-if="searchData.Client !== ''">
            <kst-tooltip clear-mode hover-only :content="SearchCatalog.Client.Label">
              <kst-button clear-mode @click="handleReset"/>
            </kst-tooltip>
          </template>
          <template v-else>
          </template>
        </div>
      </template>
      </kst-input>
    </div>

    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="SearchCatalog"
        @input="handleInput"
      />
    </div>

      <div class="column is-narrow">
        <kst-button reset-mode @click="handleReset"/>
      </div>
    </div>
  </form>
</template>

<script>
import SearchCatalog from "./InvoiceSearchCatalog.js";
import SearchMixin from "@/mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  props: {
    searchData: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog
  }),
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleInput() {
      this.handleSearch();
    },
    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>